import { Body, Box } from './'
import podAndHiveLogo from '../../assets/podAndHiveLogo.svg'

export const MadeByPodAndHive = (props) => (
  <a href="https://www.podandhive.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }} {...props}>
    <Box gap={8} alignItems="center">
      <Body>made by</Body>
      <img src={podAndHiveLogo} alt="Pod and Hive Logo"/>
    </Box>
  </a>
)